import { render, staticRenderFns } from "./details-modal.vue?vue&type=template&id=0446515a&"
import script from "./details-modal.vue?vue&type=script&lang=ts&"
export * from "./details-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports